<div class="status-item-name" title="{{status.name}}">
    <strong [ngStyle]="{ 'color': status.color }">{{status.name}}</strong>
</div>
